<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * ICMS item category system* * * * * * * * * * * *  -->
<!-- * * * * * * * * * * siemcorp.com * * * * * * * * * * * * * *  -->
<!-- * * * * * * * * * * 4/5/2020  * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<div class="container">
  <div class="rightNav">
    <ul class="navItems" >
      <li class="navItems">
        <app-artie-says></app-artie-says>
      </li>
      <li class="navItems">
        <H1>don't panic</H1>
      </li>
      <li class="navItems">
        <a id="SKWBtn" routerLink="/home" routerLinkActive="active"></a>
      </li>
      <li class="navItems">
        <a id="InfoBtn" routerLink="/about" ></a>
      </li>
    </ul>

  </div>
  <router-outlet></router-outlet>



</div>
<div id="footer">
  Copyright 2002 - 2024 - Sumner Internet Marketing Environments Corporation - <a href="mailto:sales@simecorp.com">sales@simecorp.com</a>
</div>


